import React from "react";
import { Link } from "react-router-dom";
import { Play, Info } from "lucide-react";
import { fileImageUrl } from "../lib/api";

export default function HeroBanner({ movie }) {
  if (!movie) return null;
  const bg = fileImageUrl(movie.backdrop_path || movie.thumbnail_path);

  return (
    <section
      data-testid="hero-banner"
      className="relative h-[80vh] min-h-[560px] max-h-[900px] w-full overflow-hidden"
    >
      {bg ? (
        <img
          src={bg}
          alt={movie.title}
          className="absolute inset-0 w-full h-full object-cover"
        />
      ) : (
        <div className="absolute inset-0 bg-zinc-900" />
      )}

      <div className="absolute inset-0 hero-scrim-side" />
      <div className="absolute inset-0 hero-scrim-bottom" />

      <div className="relative z-10 max-w-[1600px] mx-auto h-full px-4 sm:px-8 lg:px-12 flex items-end pb-20 sm:pb-28">
        <div className="max-w-2xl space-y-6">
          <div className="flex items-center gap-3 flex-wrap">
            {movie.is_4k && (
              <span className="font-mono-mini text-[11px] px-3 py-1 border border-[color:var(--ns-accent)] text-[color:var(--ns-accent)] uppercase tracking-[0.3em]">
                4K · HDR · DOLBY 5.1
              </span>
            )}
            <span className="font-mono-mini text-[11px] px-3 py-1 border border-white/20 text-white uppercase tracking-[0.3em]">
              {movie.genre || "Cinéma"}
            </span>
            <span className="font-mono-mini text-[11px] text-zinc-400 uppercase tracking-[0.3em]">
              {movie.year}
            </span>
          </div>

          <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl text-white uppercase leading-[0.95] tracking-tight">
            {movie.title}
          </h1>

          <p className="text-sm sm:text-base text-zinc-300 leading-relaxed line-clamp-3 max-w-xl">
            {movie.synopsis}
          </p>

          <div className="flex items-center gap-3 pt-2">
            <Link
              to={`/movie/${movie.id}?play=1`}
              data-testid="hero-play-button"
              className="inline-flex items-center gap-2 px-6 py-3 btn-accent rounded-full font-semibold text-sm uppercase tracking-widest"
            >
              <Play size={16} fill="currentColor" /> Lecture
            </Link>
            <Link
              to={`/movie/${movie.id}`}
              data-testid="hero-info-button"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 border border-white/15 hover:bg-white/15 rounded-full text-white text-sm uppercase tracking-widest transition"
            >
              <Info size={16} /> Plus d&apos;infos
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
